import Logo from '../../assets/app/logo.png'
const LoadingPage = () => {
    return <div className='w-screen h-screen flex items-center justify-center'>
        <img className='animate-bounce ' src={Logo} />
    </div>
}

export { LoadingPage }